import { useQuery } from "@tanstack/react-query";
import { usePermissions } from "@/context/PermissionsContext";
import { BOUNCER_PERMISSIONS } from "@/constants/bouncerPermissions";
import { listRfqInvitations } from "@/services/rfqService";
import { rfqKeys } from "../api/queryKeys";
import type { VendorRfqListParams, VendorRfqListResponse } from "../types";

const PROBE: VendorRfqListParams = { limit: 1, offset: 0 };

export function hasInvitations(inbox: Partial<VendorRfqListResponse> | null | undefined): boolean {
  if (!inbox) return false;
  return Object.values(inbox.counts ?? {}).some((count) => Number(count) > 0) || Number(inbox.total) > 0 || Number(inbox.items?.length) > 0;
}

export function useRfqAccess(): boolean {
  const { hasPermission } = usePermissions();
  const permitted = hasPermission(BOUNCER_PERMISSIONS.RFQ_VIEW);
  const { data } = useQuery(rfqKeys.list(PROBE), () => listRfqInvitations(PROBE), {
    enabled: permitted,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return permitted && hasInvitations(data);
}
